import { NavigateWithThread, FocusDashboard, Profile, TopSkillDetailPage } from '@yeshuman/sdk'
import { Routes, Route } from 'react-router-dom'
import { BriefsPage } from '../../../components/recruiter/briefs-page'
import { BriefCreatePage } from '../../../components/recruiter/brief-create-page'
import { BriefDetailPage } from '../../../components/recruiter/brief-detail-page'
import { RecruiterTalentPage } from '../../../components/recruiter/recruiter-talent-page'
import { RecruiterEvaluationAnalysisRoute } from '../../../components/recruiter/recruiter-evaluation-analysis-route'
import { RecruiterPersonMatchPage } from '../../../components/recruiter/recruiter-person-match-page'
import { RecruiterPipelinePage } from '../../../components/recruiter/recruiter-pipeline-page'
import { RecruiterClientJobsPage } from '../../../components/recruiter/recruiter-client-jobs-page'
import {
  JobWorkspaceApplicantsRoute,
  JobWorkspaceDefaultRedirect,
  JobWorkspaceSuggestionsRoute,
  JobWorkspaceTalentRoute,
  RecruiterJobWorkspaceLayout,
} from '../../../components/employer/job-workspace-page'

interface RecruiterRoutesProps {
  onStartConversation?: (message: string) => void
}

export function RecruiterRoutes({ onStartConversation }: RecruiterRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={
          <FocusDashboard
            focus="recruiter"
            onStartConversation={onStartConversation}
          />
        }
      />
      <Route path="profile/top-skills/:skillId" element={<TopSkillDetailPage />} />
      <Route path="profile" element={<Profile />} />
      <Route path="talent/analysis/:evaluationId" element={<RecruiterEvaluationAnalysisRoute />} />
      <Route path="talent/people/:profileId" element={<RecruiterPersonMatchPage />} />
      <Route path="talent" element={<RecruiterTalentPage />} />
      <Route path="briefs/:briefId/people/:profileId" element={<RecruiterPersonMatchPage />} />
      <Route path="pipeline" element={<RecruiterPipelinePage />} />
      <Route path="jobs" element={<RecruiterClientJobsPage />} />
      <Route path="jobs/:jobId" element={<RecruiterJobWorkspaceLayout />}>
        <Route index element={<JobWorkspaceDefaultRedirect />} />
        <Route path="applicants" element={<JobWorkspaceApplicantsRoute />} />
        <Route path="applicants/:applicationId" element={<JobWorkspaceApplicantsRoute />} />
        <Route path="talent" element={<JobWorkspaceTalentRoute />} />
        <Route path="suggestions" element={<JobWorkspaceSuggestionsRoute />} />
      </Route>
      <Route path="briefs" element={<BriefsPage />} />
      <Route path="briefs/new" element={<BriefCreatePage />} />
      <Route path="briefs/:briefId" element={<BriefDetailPage />} />
      <Route path="*" element={<NavigateWithThread to="" />} />
    </Routes>
  )
}
